var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-page"},[_c('div',{staticClass:"box",style:({
            borderBottomWidth: _vm.configData.heightConfig.val + 'px',
            borderBottomColor: _vm.configData.lineColor.color[0].item,
            borderBottomStyle: _vm.configData.lineStyle.list[_vm.configData.lineStyle.type].style,
            marginLeft: _vm.configData.lrEdge.val +'px',
            marginRight:_vm.configData.lrEdge.val +'px',
            marginTop: _vm.configData.mbConfig.val +'px',
        })})])}
var staticRenderFns = []

export { render, staticRenderFns }